import { Link } from 'react-router-dom';
import { movies } from '@/mocks/data';
import MovieCard from '@/components/base/MovieCard';

interface MovieSectionProps {
  title: string;
  subtitle?: string;
  filterKey: 'isHot' | 'isNew' | 'isClassic';
  viewAllLink?: string;
}

export default function MovieSection({ title, subtitle, filterKey, viewAllLink }: MovieSectionProps) {
  const filteredMovies = movies.filter((m) => m[filterKey]);

  return (
    <section className="py-10 md:py-14">
      <div className="w-full max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="flex items-end justify-between mb-8">
          <div>
            <h2 className="text-xl md:text-2xl font-bold text-foreground-50 font-heading">{title}</h2>
            {subtitle && <p className="text-sm text-foreground-500 mt-1">{subtitle}</p>}
          </div>
          {viewAllLink && (
            <Link
              to={viewAllLink}
              className="flex items-center gap-1 text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer"
              onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
            >
              查看全部 <i className="ri-arrow-right-line text-xs"></i>
            </Link>
          )}
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-3 md:gap-4">
          {filteredMovies.map((movie) => (
            <MovieCard
              key={movie.id}
              slug={movie.slug}
              title={movie.title}
              titleEn={movie.titleEn}
              coverImage={movie.coverImage}
              rating={movie.rating}
              year={movie.year}
              category={movie.category}
              region={movie.region}
              tags={movie.tags}
            />
          ))}
        </div>
      </div>
    </section>
  );
}